import { render, staticRenderFns } from "./product_prices.vue?vue&type=template&id=51e19613&scoped=true&"
import script from "./product_prices.vue?vue&type=script&lang=js&"
export * from "./product_prices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e19613",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51e19613')) {
      api.createRecord('51e19613', component.options)
    } else {
      api.reload('51e19613', component.options)
    }
    module.hot.accept("./product_prices.vue?vue&type=template&id=51e19613&scoped=true&", function () {
      api.rerender('51e19613', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/tabs/product_prices.vue"
export default component.exports